<!--  -->
<template>
  <div class="">
    <div class="selsect">
      <!-- <el-select
        v-model="value"
        class="dropdown"
        placeholder="请选择学届"
        @visible-change="dropdownAcademicSelectSearch"
        @change="chooseAcademicValue"
      >
        <el-option
          v-for="item in AcademicOptions"
          :key="item.Name"
          :value="item.Name"
        >
        </el-option>
      </el-select> -->
      <el-select
        v-if="userInfo.uID == 12"
        v-model="SchoolName"
        placeholder="请选择所属幼儿园"
        @visible-change="onScrollData"
        @change="onChangeScrollData"
      >
        <el-option
          v-for="item in SchoolList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>

      <el-input
        v-model="cycleName"
        placeholder="请输入名称"
        style="width: 200px"
      ></el-input>

      <el-button
        style="margin-left: 20px"
        type="primary"
        @click="GetStudyYearsInfoByPage"
        >查询</el-button
      >
      <el-button type="primary" @click="addCycle">新增</el-button>
      <el-button type="primary" @click="clear">清空选项</el-button>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        border
        style="width: 100%; margin: 0 auto"
        :header-cell-style="{ background: '#F2F5FF', color: '#333' }"
        empty-text="暂无数据"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="序号" width="55">
          <template slot-scope="scope">
            {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="StudyYearName" label="学届"> </el-table-column>
        <el-table-column prop="SchoolName" label="所属幼儿园">
        </el-table-column>
        <el-table-column prop="CreateTime" label="创建时间"> </el-table-column>
        <el-table-column label="状态" prop="Status"></el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.Status"
              active-text="启用"
              inactive-text="关闭"
              active-value="启用"
              inactive-value="关闭"
              @change="onChangeOpen($event, scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作">
     <template slot-scope="scope">
        <el-button
          size="mini"
          type="primary"
          @click="handleEdit(scope.$index, scope.row)"
         >编辑</el-button>
      </template>
    </el-table-column> -->
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="PageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center;padding:20px; 0 0 0"
      >
      </el-pagination>
    </div>
    <el-dialog :title="nameTitle" :visible.sync="dialogVisible" width="30%">
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          :label-position="`top`"
        >
          <el-form-item label="学届年份" prop="name">
            <el-input type="number" v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="所属幼儿园" v-if="userInfo.uID == 12">
            <el-select
              v-model="ruleForm.addSchoolName"
              placeholder="请选择幼儿园"
              @visible-change="addOnScrollData"
            >
              <el-option
                v-for="item in addSchoolList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="
            nameTitle == '新增'
              ? submitForm('ruleForm')
              : EditsubmitForm('ruleForm')
          "
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { number } from "echarts/lib/export";
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  GetStudyYearsInfoByPage,
  getAcademicSelect,
  GetGradeList,
  AddStudyYearsInfo,
  UpdateCycleInfo,
  DeleteCycleInfo,
  GetSchoolList,
  UpdateStudyYearInfo,
} from "../../api/api";
export default {
  data() {
    //这里存放数据
    return {
      title: "周期管理",
      tableData: [],
      dialogVisible: false,
      checkStatus: false,
      value: "",
      AcademicName: "", //学届名称
      AcademicId: "", //学届ID
      type: "", //类型
      cycle: "", //周期
      AcademicOptions: [], //学届下拉列表
      cycleOptions: [], //周期下拉列表
      selsectId: [], //多选信息id
      page: 1,
      pageCount: 0,
      ruleForm: {
        name: 0,
        addSchoolName: "",
      },
      rules: {
        name: [{ required: true, message: "请输入学届年份", trigger: "blur" }],
      },
      optionsStudy: [], //学届下拉
      optionsGrade: [],
      nameTitle: "新增",
      SchoolList: [],
      SchoolName: null,
      addSchoolList: [],
      testOpen: "1",
      cycleName: "",
      PageIndex: 1,
      PageSize: 10,
      total: 0,
      userInfo: {},
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetStudyYearsInfoByPage();
      //console.log(val);
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetStudyYearsInfoByPage();
    },
    async onScrollData() {
      let res = await GetSchoolList();
      if (res.data.success) {
        this.SchoolList = res.data.response;
      }
    },
    async addOnScrollData() {
      let res = await GetSchoolList();
      if (res.data.success) {
        this.addSchoolList = res.data.response;
      }
    },
    onChangeScrollData(e) {
      this.SchoolName = e;
      this.GetStudyYearsInfoByPage();
    },
    //删除
    onClickDelete(item) {
      DeleteCycleInfo({ ids: [item.Id] }).then((res) => {
        if (res.status == 200) {
          this.GetStudyYearsInfoByPage();
          this.$message({
            message: "操作成功",
            type: "success",
          });
        }
      });
    },

    // 编辑
    onClickEdit(item) {
      getAcademicSelect({ schoolId: item.SchoolId }).then((res) => {
        if (res.data.success) {
          this.addOnScrollData();
          this.optionsStudy = res.data.response;
          this.nameTitle = "编辑";
          this.dialogVisible = true;
          this.checkStatus = true;
          //console.log(item);
          this.ruleForm = {
            name: item.CycleName,
            StudyName: Number(item.StudyYearId),
            Grade: item.GradeId,
            addSchoolName: Number(item.SchoolId),
            Id: item.Id,
          };
        }
      });
      //console.log(item);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            SchoolId:
              this.userInfo.uID == 12
                ? this.ruleForm.addSchoolName
                : this.userInfo.SchoolId,
            studyYearName: this.ruleForm.name,
          };
          AddStudyYearsInfo(params).then((res) => {
            if (res.data.success) {
              this.$message({
                type: "success",
                message: res.data.msg,
              });
              this.dialogVisible = false;
              this.GetStudyYearsInfoByPage();
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
          });
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    EditsubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            Id: this.ruleForm.Id,
            sort: this.ruleForm.sort,
          };
          UpdateCycleInfo(params).then((res) => {
            if (res.data.success) {
              this.$message({
                type: "success",
                message: res.data.msg,
              });
              this.dialogVisible = false;
              this.GetStudyYearsInfoByPage();
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
          });
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    //下拉年级菜单
    dropdownGradeSelect() {
      GetGradeList({ schoolId: this.ruleForm.addSchoolName }).then((res) => {
        //  //console.log(res);
        this.optionsGrade = res.data.response;
      });
    },

    addCycle() {
      this.ruleForm = {
        name: "",
        StudyName: "",
        Grade: "",
        sort: "",
        addSchoolName: "",
        Id: 0,
      };
      this.dialogVisible = true;
      this.checkStatus = false;
    },
    async GetStudyYearsInfoByPage() {
      let params = {
        pageIndex: this.pageIndex,
        PageSize: this.PageSize,
        schoolId:
          this.userInfo.uID == 12 ? this.SchoolName : this.userInfo.SchoolId,
        StudyYearName: this.cycleName,
      };
      let res = await GetStudyYearsInfoByPage(params);

      if (res.data.success) {
        // //console.log(res.data.response.data);
        this.tableData = res.data.response.data;
        this.pageCount = res.data.response.pageCount;
        // //console.log(this.pageCount);
      } else {
        this.tableData = [];
        this.pageCount = 0;
      }
    },
    //下拉学届菜单接口
    dropdownAcademicSelect(show) {
      if (show === true) {
        getAcademicSelect({ schoolId: this.ruleForm.addSchoolName }).then(
          (res) => {
            if (res.data.success) {
              // //console.log(res.data.response);
              this.optionsStudy = res.data.response;
            }
          }
        );
      }
    },
    dropdownAcademicSelectSearch(show) {
      if (show === true) {
        getAcademicSelect({ schoolId: this.ruleForm.addSchoolName }).then(
          (res) => {
            if (res.data.success) {
              // //console.log(res.data.response);
              this.AcademicOptions = res.data.response;
            }
          }
        );
      }
    },
    //选择学届菜单项
    chooseAcademicValue(name) {
      this.AcademicName = name;
      var obj = {};
      obj = this.AcademicOptions.find((item) => {
        return item.Name == name;
      });
      this.AcademicId = obj.Id;
    },

    clear() {
      this.SchoolName = "";
      this.cycleName = "";
    },
    async onChangeOpen(e, item) {
      //console.log(e, item);
      let params = {
        ids: [item.Id],
        Status: e == "启用" ? 1 : 0,
      };
      let res = await UpdateStudyYearInfo(params);
      if (res.data.success) {
        this.GetStudyYearsInfoByPage();
      }
    },
  },

  mounted() {
    this.userInfo = JSON.parse(window.localStorage.user);
    this.GetStudyYearsInfoByPage();
  },
};
</script>
<style scoped>
.colorBlur {
  color: #a0cfff !important;
}

.btns {
  margin-top: 20px;
  margin-left: 20px;
}
.search {
  margin-left: 30px !important;
}
.table {
  margin: 20px 0 0 0;
}
.paging {
  margin-left: 20px;
  margin-top: 20px;
}
.last_btn {
  margin-left: 20px !important;
}
</style>